:host {
  @include spaceCurve('--row-gap', 'regular');

  --grid-template-areas: var(
      --stzh-textandimage-grid-template-areas,
      "text text text text" "image image image image"
  );

  --grid-template-columns: var(
      --stzh-textandimage-grid-template-columns,
      #{$gridColumns}
  );

  @include mq($from: medium) {
    --grid-template-areas: var(
        --stzh-textandimage-grid-template-areas,
        "text text text text image image image image"
    );

    --grid-template-columns: var(
        --stzh-textandimage-grid-template-columns,
        #{$gridColumnsMedium}
    );
  }
}


:host([image-position="left"]) {
  @include mq($from: medium) {
    --grid-template-areas: var(
        --stzh-textandimage-grid-template-areas-image-left,
        "image image image image text text text text"
    );
  }
}

:host([size="small"]) {
  @include mq($from: medium) {
    --grid-template-areas: var(
        --stzh-textandimage-small-grid-template-areas,
        "text text text text text image image image"
    );
  }
}

:host([size="small"][image-position="left"]) {
  @include mq($from: medium) {
    --grid-template-areas: var(
        --stzh-textandimage-small-grid-template-areas,
        "image image image text text text text text"
    );
  }
}

:host([size="large"]) {
  @include mq($from: small) {
    --grid-template-areas: var(
        --stzh-textandimage-large-grid-template-areas,
        "text text text ." "image image image image"
    );
  }

  @include mq($from: medium) {
    --grid-template-areas: var(
        --stzh-textandimage-large-grid-template-areas,
        "text text text text text . . ." "image image image image image image image image"
    );
  }

  @include mq($from: large) {
    --grid-template-areas: var(
        --stzh-textandimage-large-grid-template-areas,
        "text text text text text text . ." "image image image image image image image image"
    );
  }
}

:host([single]:not([single="false"])) {
  --grid-template-areas: var(
      --stzh-textandimage-single-grid-template-areas,
      "text text text text"
  );

  @include mq($from: small) {
    --grid-template-areas: var(
        --stzh-textandimage-single-grid-template-areas,
        "text text text ."
    );
  }

  @include mq($from: medium) {
    --grid-template-areas: var(
        --stzh-textandimage-single-grid-template-areas,
        "text text text text text text . ."
    );
  }
}

.stzh-textandimage {
  @include gridGutter;
  display: grid;
  row-gap: var(--row-gap);
  grid-template-areas: var(--grid-template-areas);
  grid-template-columns: var(--grid-template-columns);

  &__left {
    grid-area: text;
  }

  &__right {
    grid-area: image;
  }

  /* Single variant */

  &--is-single &__right {
    grid-area: text;
  }

  &--is-single-left &__right {
    display: none;
  }

  &--is-single-right &__left {
    display: none;
  }
}
